import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid2';
import { withStyles } from '@mui/styles';
import {useSnackbar} from "notistack";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {Link, useNavigate} from "react-router-dom";
import {defaultVariables} from "../../../config";
import {Styles} from "../../../config/design/styles";
import WishlistSkeleton from "../../components/loaders/WishlistSkeleton";
import VendorSliderItem from "../front/shops/components/VendorSliderItem";
import {ChevronLeft, PackageOpen} from "lucide-react";
import NothingFound from "../../components/elements/NothingFound";


function Favorites({classes,setTotal}){
    const { t } = useTranslation();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigation = useNavigate();
    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    };
    const { enqueueSnackbar } = useSnackbar();
    const loadData = () =>{
        axios.get(`${defaultVariables.url}/user/get-wishlist`,config)
            .then(response => {
                setData(response.data);
                if(!!setTotal) setTotal(response.data.length)

                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
            });
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
        loadData();
    },[]);


    return (
        <Grid container spacing={2} justify="center">
            {
                loading ? <WishlistSkeleton/>
                    :
                    <>
                        {
                            data.length > 0 ?
                            data.map((item,index)=> (
                                <Grid item size={{xs:12,sm:6,md:4,lg:3}} key={index}>
                                    <VendorSliderItem vendor={item.shop} wishlist/>
                                </Grid>
                            ))
                                :
                                <Grid item size={{xs:12}}>
                                    <NothingFound
                                        type="page"
                                        title={t('noItemFoundInWishlist')}
                                        title_color="text"
                                        paragraph={t('tryAddSomeItemsToWishlist')}
                                        icon={<PackageOpen/>}
                                    >
                                    </NothingFound>
                                </Grid>
                        }
                    </>
            }
        </Grid>
    );
}
export default withStyles(Styles)(Favorites);
